import _ from 'lodash';
import React from 'react';
import moment from 'moment';

import { Icon } from 'semantic-ui-react';

import { ListView } from '@jvs-group/jvs-mairistem-composants';

import ReservationListViewAction from './ReservationListViewAction';
import ReservationListViewPictos from './ReservationListViewPictos';

const ReservationListView = (props) => {
    const { onAddClick, items } = props;

    return (
        <ListView
            permanentView
            viewWidth={400}
            items={_.map(items, ({
                identifiant,
                dateDebut,
                dateFin,
                statut,
                type,
                nombrePersonne,
                accessibilite,
                complementInformation,
                reservant,
            }) => {
                const {
                    nom: nomReservant,
                    prenom,
                    typeReservant,
                } = reservant || {};

                const { webdev } = window;

                // Personne physique ou morale
                const physique = typeReservant === 'Particulier';

                const startDate = moment(dateDebut).format('D MMM');
                const startHour = moment(dateDebut).format('HH:mm');
                const endDate = moment(dateFin).format('D MMM');
                const endHour = moment(dateFin).format('HH:mm');

                const isMaintenance = (accessibilite === 'Maintenance');

                // On adapte le nom s'il s'agit d'une association ou d'un particulier
                const nomReservantAffiche = physique
                    ? `${prenom} ${nomReservant}`
                    : `${nomReservant}`;

                // Si la réservation est une maintenance alors on a pas de nom de réservant
                let libelleReservant = isMaintenance
                    ? 'Indisponible'
                    : `Réservation faite par ${nomReservantAffiche}`;

                // Méthode de redirection vers la fiche réservation
                const handleClickReservation = () => {
                    vAfficheReservation(identifiant); // eslint-disable-line
                };

                // En intégration webdev on a besoin d'une redirection vers la fiche
                const title = !webdev
                    ? libelleReservant
                    : (<a
                        style={{ color: '#5270A9' }}
                        onClick={handleClickReservation}
                    >
                        🔗 {libelleReservant}
                    </a>);

                return ({
                    identifiant,
                    title: (
                        <>
                            {isMaintenance && (
                                <Icon
                                    name='warning sign'
                                    size='small'
                                    style={{ paddingRight: 5, marginTop: -2 }}
                                    title='En maintenance'
                                />
                            )}
                            {isMaintenance
                                ? 'Maintenance'
                                : nomReservantAffiche
                            }
                        </>
                    ),
                    subtitle: _.isNil(dateDebut)
                        ? ''
                        : `Du ${startDate} à ${_.replace(startHour, ':', 'h')} au ${endDate} à ${_.replace(endHour, ':', 'h')}`,
                    view: {
                        title: title,
                        descriptionTitle: 'Observation :',
                        description: complementInformation,
                        footer: (<ReservationListViewPictos
                            dateDebut={dateDebut}
                            dateFin={dateFin}
                            statut={statut}
                            type={type}
                            nombrePersonne={nombrePersonne}
                            maintenance={isMaintenance}
                        />)
                    }
                })
            })}
            action={<ReservationListViewAction onAddClick={onAddClick} />}
        />
    )
};

ReservationListView.defaultProps = {
    items: []
}

export default ReservationListView;